<template>
  <div class="uk-container uk-margin-small-top">
    <h2 class="uk-heading-small uk-text-center">Create a New Project</h2>
    <p class="uk-text-center">Enter some basic info to get started.</p>
    <form class="uk-form-stacked uk-width-1-2@s uk-align-center">
      <div class="uk-margin">
        <label class="uk-form-label" for="fName">First Name</label>
        <div class="uk-form-controls">
          <input
            class="uk-input"
            id="fName"
            type="text"
            v-model="tempBasicInfo.fName"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="lName">Last Name</label>
        <div class="uk-form-controls">
          <input
            class="uk-input"
            id="lName"
            type="text"
            v-model="tempBasicInfo.lName"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="email">Email</label>
        <div class="uk-form-controls">
          <input
            class="uk-input"
            id="email"
            type="text"
            v-model="tempBasicInfo.email"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="email">Phone</label>
        <div class="uk-form-controls">
          <input
            class="uk-input"
            id="phone"
            type="text"
            v-model="tempBasicInfo.phone"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="company">Company</label>
        <div class="uk-form-controls">
          <input
            class="uk-input"
            id="company"
            type="text"
            v-model="tempBasicInfo.company"
          />
        </div>
      </div>

      <div class="uk-margin">
        <label class="uk-form-label" for="estimatedOrderVolume"
          >Estimated Order Volume</label
        >
        <div class="uk-form-controls">
          <select
            class="uk-select"
            id="estimatedOrderVolume"
            v-model="tempBasicInfo.estimatedOrderVolume"
          >
            <option disabled value="Select an option">Select an option</option>
            <option>Less than 10 items</option>
            <option>11-99 items</option>
            <option>100+ items</option>
          </select>
        </div>
      </div>

      <div class="uk-margin">
        <div class="uk-form-label">
          Select the Products You're Interested In
        </div>
        <div class="uk-form-controls">
          <div
            uk-grid="margin: uk-grid-margin-small"
            class="uk-margin uk-grid-medium uk-child-width-1-2@m uk-grid"
          >
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.ties"
                />
                Ties
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Durable ties designed to look and feel like silk with a soft
                    hand, minimal sheen and subtle texture. Choose from three
                    widths and four lengths. Constructed in the USA with high
                    quality polyester twill fabric made from recycled plastic
                    bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.bowTies"
                />
                Bow Ties
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Durable bow ties designed to look and feel like silk with a
                    soft hand, minimal sheen and subtle texture. Adult and kids,
                    self-tie and pretied available. Constructed in the USA with
                    a high quality polyester twill fabric made from recycled
                    plastic bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.pocketSquares"
                />
                Pocket Squares
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Durable pocket squares designed to look and feel like silk
                    with a soft hand, minimal sheen and subtle texture. Finely
                    finished thread wrapped edges. Constructed in the USA with
                    high quality polyester twill fabric made from recycled
                    plastic bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.chiffonScarves"
                />
                Chiffon Scarves
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Lightweight and sheer scarf featuring an elegant silk-like
                    feel and drape. Finely finished thread wrapped edges.
                    Multiple sizes available. Constructed in the USA with high
                    quality polyester chiffon fabric made from recycled plastic
                    bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.neckGaiters"
                />
                Neck Gaiters
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Breathable and flexible gaiters. Available in lightweight or
                    insulated fabric, single or double layer. Constructed in the
                    USA.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.hairScarves"
                />
                Hair Scarves
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Lightweight hair scarf featuring an elegant silk-like feel.
                    One size fits all. Constructed in the USA with high quality
                    polyester crepe de chine fabric.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.robes"
                />
                Robes
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Unisex robes are lightweight and designed to be casual and
                    flattering with three quarter length sleeves and a
                    kimono-style body with an open front and waist belt closure.
                    Multiple sizes available. Constructed in the USA with high
                    quality, ultra-soft, cotton-like polyester.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.kimonos"
                />
                Kimonos
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Lightweight and sheer kimono featuring an elegant silk-like
                    feel and drape. Finely finished thread wrapped edges.
                    Multiple sizes available. Constructed in the USA with high
                    quality polyester chiffon fabric made from recycled plastic
                    bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.tableRunners"
                />
                Table Runners
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Printed runners designed to look and feel like silk with a
                    soft hand, minimal sheen and subtle texture. Laser cut edges
                    eliminate fraying and allow runners to lay flat and smooth.
                    Sold as a set of 4 and available in multiple sizes.
                    Constructed in the USA with high quality polyester twill
                    fabric made from recycled plastic bottles.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.infinityScarves"
                />
                Infinity Scarves
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Lightweight scarf featuring an elegant silk-like feel and
                    drape sewn into a continuos loop. One size fits all.
                    Constructed in the USA with high quality polyester crepe de
                    chine fabric.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <label>
                <input
                  class="uk-checkbox"
                  type="checkbox"
                  v-model="tempBasicInfo.productInterest.suspenders"
                />
                Suspenders
              </label>
              <span uk-icon="icon: info"></span>
              <div uk-drop="delay-hide:300">
                <div class="uk-card uk-card-body uk-card-default">
                  <p>
                    Durable suspenders designed to closely match texture and
                    color of ties and bow ties. Adjustable front straps joined
                    to flexible back elastic via brown vegan leather y-back.
                    Adult and kids sizes available. Constructed in the USA with
                    high quality polyester twill fabric made from recycled
                    plastic bottles.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-margin">
        <div class="uk-form-label">In-Hand Deadline</div>
        <div class="uk-form-controls">
          <flat-pickr
            class="uk-input"
            id="deadline"
            type="text"
            v-model="tempBasicInfo.deadline"
            :config="flatPickrConfig"
          ></flat-pickr>
        </div>
      </div>
    </form>
    <div class="uk-width-1-2@s uk-align-center">
      <div class="uk-margin uk-align-right">
        <button
          v-if="isComplete"
          class="uk-button uk-button-primary"
          v-on:click="setBasicInfo()"
        >
          Continue
        </button>
        <button disabled v-if="!isComplete" class="uk-button uk-button-primary">
          Complete All fields to continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CrmService from "@/services/CrmService";
import LogRocket from "logrocket";

export default {
  name: "CreateOrgProject",
  data() {
    return {
      tempBasicInfo: {
        fName: null,
        lName: null,
        email: null,
        phone: null,
        company: null,
        productInterest: {
          ties: false,
          bowTies: false,
          pocketSquares: false,
          chiffonScarves: false,
          neckGaiters: false,
          hairScarves: false,
          kimonos: false,
          robes: false,
          tableRunners: false,
          infinityScarves: false,
          suspenders: false
        },
        estimatedOrderVolume: null,
        deadline: null,
        adSource: null,
        segment: "organization",
        saved: false
      },
      flatPickrConfig: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M	j, Y",
        altInput: true,
        dateFormat: "Y-m-d"
      }
    };
  },
  methods: {
    setBasicInfo() {
      CrmService.partialInquiry(this.tempBasicInfo);
      LogRocket.identify(this.tempBasicInfo.email);
      setTimeout(() => {
        this.$store.commit("newOrgProject/setBasicInfo", this.tempBasicInfo);
        this.$router.push({ name: "SelectOrgStyles" });
      }, 500);
    }
  },
  computed: {
    basicInfo() {
      return this.$store.state.newOrgProject.basicInfo;
    },
    isComplete() {
      if (
        this.tempBasicInfo.fName &&
        this.tempBasicInfo.lName &&
        this.hasProduct &&
        this.tempBasicInfo.deadline &&
        this.tempBasicInfo.estimatedOrderVolume &&
        this.emailIsValid
      ) {
        return true;
      }
    },
    hasProduct() {
      for (
        var i = 0;
        i < Object.values(this.tempBasicInfo.productInterest).length;
        i++
      ) {
        if (Object.values(this.tempBasicInfo.productInterest)[i]) {
          return true;
        }
      }
    },
    emailIsValid() {
      if (
        this.tempBasicInfo.email &&
        this.tempBasicInfo.email.includes("@") &&
        this.tempBasicInfo.email.includes(".")
      ) {
        return true;
      }
    }
  },
  mounted: function() {
    if (this.basicInfo.saved) {
      this.tempBasicInfo = JSON.parse(JSON.stringify(this.basicInfo));
    }
    if (this.$route.query.adSource) {
      const adSource = this.$route.query.adSource;
      this.tempBasicInfo.adSource = adSource;
    }
  },
  components: {
    flatPickr
  }
};
</script>

<style type="text/css">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/org-onboarding/CreateOrgProject.vue